/* eslint-disable no-unused-vars */
export enum NotificationsActionType {
  GET_NOTIFICATIONS = 'get_notifications',
  GET_NOTIFICATIONS_SUCCESS = 'get_notifications_success',
  GET_NOTIFICATIONS_FAILURE = 'get_notifications_failure',
}
